/**
 * STAHLFRONT factions — locked WW2 nations per Vadim's call.
 * Real historical names; lore + UI copy is original.
 */
export type Faction = "USSR" | "WEHRMACHT" | "US" | "UK";

export const FACTIONS: readonly Faction[] = ["USSR", "WEHRMACHT", "US", "UK"] as const;

export type Doctrine =
  | "BLITZKRIEG"
  | "DEEP_BATTLE"
  | "OVERWHELMING_FIREPOWER"
  | "COMBINED_ARMS";

export interface FactionConfig {
  readonly id: Faction;
  readonly displayName: string;
  /** OKLCH accent used for map influence zones, banners, alliance plates. */
  readonly accentOklch: string;
  readonly defaultDoctrine: Doctrine;
}

export const FACTION_CATALOG: Readonly<Record<Faction, FactionConfig>> = {
  USSR: {
    id: "USSR",
    displayName: "Soviet Union",
    accentOklch: "oklch(58% 0.19 25)",
    defaultDoctrine: "DEEP_BATTLE",
  },
  WEHRMACHT: {
    id: "WEHRMACHT",
    displayName: "Wehrmacht",
    accentOklch: "oklch(40% 0.04 250)",
    defaultDoctrine: "BLITZKRIEG",
  },
  US: {
    id: "US",
    displayName: "United States",
    accentOklch: "oklch(50% 0.12 145)",
    defaultDoctrine: "OVERWHELMING_FIREPOWER",
  },
  UK: {
    id: "UK",
    displayName: "United Kingdom",
    accentOklch: "oklch(46% 0.13 245)",
    defaultDoctrine: "COMBINED_ARMS",
  },
};
